import types from "../actions";
import Storage from "../../services/localStorage";

const initialState = Storage.get('token') ? Storage.get('user') : null;

export default function (state = initialState, action) {
  switch (action.type) {
    case types.USER_INFO:
      return { ...state, ...action.payload };
    case types.USER_LOGOUT:
      return null;
    default:
      return state;
  }
}
